<template>
  <section id="clients" class="columns">
    <div id="clientsContainer" class="column container is-3">
      <b-collapse :open="false" aria-id="contentIdForA11y1" class="has-text-centered">
        <b-button
          type="is-dark"
          icon-right="menu-down"
          slot="trigger"
          aria-controls="contentIdForA11y3"
        >Client List</b-button>
        <div id="clientsList" class="is-centered box has-text-left">
          <b-tabs position="is-centered" v-model="activeTab">
            <b-tab-item label="Music">
              <ul>
                <h3
                  class="subtitle is-size-3-desktop is-size-4-mobile has-text-weight-medium mb-2"
                >Music</h3>
                <li>
                  <a href="https://www.defjam.com/" target="_blank">Def Jam</a>
                </li>
                <li>
                  <a href="http://www.atlanticrecords.com/" target="_blank">Atlantic</a>
                </li>
                <li>
                  <a href="http://www.republicrecords.com/" target="_blank">Republic</a>
                </li>
                <li>
                  <a href="https://www.universalmusic.com/" target="_blank">Universal</a>
                </li>
                <li>
                  <a href="https://www.capitolrecords.com/" target="_blank">Capital</a>
                </li>
              </ul>
            </b-tab-item>

            <b-tab-item label="Sports">
              <ul>
                <h3
                  class="subtitle is-size-3-desktop is-size-4-mobile has-text-weight-medium mb-2"
                >Sports</h3>
                <li>
                  <a href="https://twitter.com/antoniogates85" target="_blank">Antonio Gates</a>
                </li>
                <li>
                  <a href="https://twitter.com/RSherman_25" target="_blank">Richard Sherman</a>
                </li>
                <li>
                  <a href="https://twitter.com/TeamLee1" target="_blank">Marqise Lee</a>
                </li>
                <li>
                  <a href="https://www.instagram.com/robertw10ds/" target="_blank">Robert Woods</a>
                </li>
                <li>
                  <a href="https://twitter.com/ZBNFL" target="_blank">Zach Banner</a>
                </li>
                <li>
                  <a href="https://www.instagram.com/ab/" target="_blank">Antonio Brown</a>
                </li>
              </ul>
            </b-tab-item>

            <b-tab-item label="Non Profits">
              <ul>
                <h3
                  class="subtitle is-size-3-desktop is-size-4-mobile has-text-weight-medium mb-1"
                >Non Profits</h3>
                <li>
                  <a
                    href="http://www.blackcelebritygiving.com/tag/macks-miracles-foundation/"
                    target="_blank"
                  >Macks Miracles</a>
                </li>
                <li>
                  <a href="https://b3foundation.org/" target="_blank">B3 Foundation</a>
                </li>
                <li>
                  <a
                    href="http://www.fam1stfamilyfoundation.org/"
                    target="_blank"
                  >Fam 1st Foundation</a>
                </li>
                <li>
                  <a href="https://athletesvscancer.com/" target="_blank">Athletes vs Cancer</a>
                </li>
                <li>
                  <a href="https://dtlr.com/" target="_blank">DLTR</a>
                </li>
              </ul>
            </b-tab-item>
          </b-tabs>
        </div>
      </b-collapse>
    </div>
  </section>
</template>
<script>
export default {
  name: "clients",
  data() {
    return {
      activeTab: 0,
    };
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#clientsList ul {
  font-size: 1.2rem;
  padding: 0.5rem 0 0 1rem;
}
#clientsList ul a {
  padding-left: 0.75rem;
}
</style>